import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-900 text-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-24 pt-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-[17px] font-bold text-background-50">
                  大桥未久
                </span>
                <span className="font-label mt-1 text-[9px] tracking-[0.22em] text-background-400">
                  FILM ARCHIVE
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-300">
              大桥未久影视内容站，聚合电影与电视剧作品资料、演员信息与影视行业资讯，
              为影视爱好者提供清晰、便捷的浏览与检索体验。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站为演示站点，作品与资讯内容均为虚构示例，不提供任何播放、下载或付费服务。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/"
                  className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/movie"
                  className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                >
                  电影作品
                </Link>
              </li>
              <li>
                <Link
                  to="/category/tv"
                  className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                >
                  电视剧作品
                </Link>
              </li>
              <li>
                <Link
                  to="/news"
                  className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                >
                  资讯中心
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="cursor-pointer text-background-300 transition-colors hover:text-accent-400"
                >
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">联系与反馈</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>content@daqiaoweijiu-demo.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400"></i>
                <span>内容更新：每周一、周四</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-400"></i>
                <span>资料纠错与版权事宜请邮件联系</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700/70 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 大桥未久影视内容站 · 本站内容仅供学习与演示使用</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>免责声明</span>
            <span className="hidden sm:inline">·</span>
            <span>版权说明</span>
            <span className="hidden sm:inline">·</span>
            <Link
              to="/about"
              className="cursor-pointer underline-offset-4 transition-colors hover:text-accent-400 hover:underline"
            >
              联系方式
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}